'use client';

import { useRef } from 'react';

import { useSymbols } from '@flipster/features/src/shared/symbol/use-symbols';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { center, grid } from '@flipster/styled-system/patterns';
import { truncateUnit } from '@flipster/utils/num';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import { maxWStyles, sectionSmallHeadingStyles } from '@web/app/[locale]/(web)/_main-page/_styles';
import { useMainPageIntersectionSegment } from '@web/app/[locale]/(web)/_main-page/hooks/useIntersectionSegment';
import { MarketCarouselType } from '@web/app/[locale]/_perp-top-market/constants';
import { usePerpTopMarkets } from '@web/app/[locale]/_perp-top-market/use-perp-top-markets';

import { PerpTopMarket } from '../../../_perp-top-market';

const Products = () => {
  const { totalSymbol } = useSymbols();
  const intersectionRef = useRef<HTMLHeadingElement>(null);
  useMainPageIntersectionSegment(intersectionRef, 'selections listed');

  // 배포 시점에 tradfi에 심볼 안들어올수 있음. 그때를 대비해 fallback 처리
  // https://prextech.slack.com/archives/C0ADFCH6N72/p1770787703530679?thread_ts=1770367479.380429&cid=C0ADFCH6N72
  const { sortedTopMarkets } = usePerpTopMarkets();
  const carouselIds: MarketCarouselType[] = sortedTopMarkets.tradfi?.length
    ? ['tradfi', 'newListings', 'priceChange24h']
    : ['newListings', 'priceChange24h', 'volume'];

  return (
    <section className={css(maxWStyles, { pt: { base: 48, tablet: 64 } }, { pb: { base: 48, tablet: 96 } })}>
      <h2 ref={intersectionRef} className={css(sectionSmallHeadingStyles)}>
        <FormattedMessage id='Main.r251104.number_selections_listed' values={{ number: truncateUnit(totalSymbol) }} />
      </h2>

      <div
        className={grid({
          gap: 16,
          mb: { base: 32, tablet: 40 },
          tablet: { gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))' },
          h: 322,
          overflow: 'hidden',
        })}
      >
        {carouselIds.map((id) => (
          <PerpTopMarket carouselId={id} key={`main-market-${id}`} />
        ))}
      </div>
      <div className={center()}>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          as='a'
          href='/market'
          onClick={() => segment.track(MainEvent.MainPageAllProductsClick)}
          label={<FormattedMessage id='Common.r251224.View_all_markets' />}
          css={{ minW: 172 }}
        />
      </div>
    </section>
  );
};

export default Products;
